module.exports = __webpack_public_path__ + "img/Step17.a4b1df76.png";